var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('P5Canvas',{on:{"setup":_vm.setup,"draw":_vm.draw}})}
var staticRenderFns = []

export { render, staticRenderFns }